import { isInkOnlyOnboardingRoute } from '@/utils/onboardingAppearance';

/** Resolve fixed Ink workspaces without changing the saved app preference.
 * Every admin page follows the saved light/dark choice (Admin overhaul Phase 3);
 * only parts of onboarding stay Ink. Keep the before-paint policy in index.html aligned.
 */
export function isInkOnlyRoute(pathname: string, search = '', isNativeRuntime = false): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  return isInkOnlyOnboardingRoute(path, search, isNativeRuntime);
}
